// Dropdown: List
// eg. Location
// 

JLM.MD.DropdownList = function( fieldset, data_list ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let dropdown, display_label, popout, popout_range, popout_range_list;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.value = '';
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let display, display_button, footer, footer_close;
		
		// Fetch references
		dropdown = $('.dropdown_list', fieldset);
		display = $('.dd_display', dropdown);
			display_button = $('button', display);
			display_label = $('.label', display_button);
		popout = $('.dd_values', dropdown);
			popout_range = $('.dd_range', popout);
				popout_range_list = $('ul', popout_range);
			footer = $('.dd_footer', popout);
			footer_close = $('button', footer);
		
		// Populate
		if ( data_list ) {
			data_list.forEach(function( entry ) {
				// Country
				let value = ( entry.value == undefined ? entry.label : entry.value );
				createOption( entry.label, value, false, entry.selected );
				
				// Cities
				if ( entry.sub ) {
					entry.sub.forEach(function( sub_entry ) {
						let sub_value = ( sub_entry.value == undefined ? sub_entry.label : sub_entry.value );
						createOption( sub_entry.label, sub_value, true, sub_entry.selected );
					});
				}
			});
		} else {
			$('li', popout_range_list).each(function() {
				let item = $(this),
					label = item.text(),
					value = item.data('value');
				setupOption( item, label, value );
			});
		}
		
		// Events
		display_button.on('click', open);
		popout_range.on('mousewheel', JLM.MT.preventScrollOverflow);
		footer_close.on('click', close);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Create a dropdown option
	// 
	function createOption( label, value, is_sub, is_selected ) {
		// Build
		const item = $('<li data-value="' + value + '">' + label + '</li>').appendTo( popout_range_list );
		if ( is_sub ) item.addClass('sub');
		if ( is_selected ) {
			item.addClass('selected');
		}
		setupOption( item, label, value );
	}
	function setupOption( item, label, value ) {
		// Set value
		if ( item.hasClass('selected') ) {
			INSTANCE.value = value;
		}
		
		// Events
		item.on('click', function() {
			select( label, value );
		});
	}
	
	
	// Open and Close
	// 
	function open() {
		if ( dropdown.attr('data-status') !== 'disabled' ) {
			let popout_height = Math.min( popout_range_list.height(), parseInt(popout_range.css('maxHeight')) );
			popout_range.css({ height: popout_height });
			dropdown.attr('data-status', 'open');
			setTimeout(function() {
				$('body').on('click', onClickOutside);
			}, 10);
		}
	}
	function close() {
		popout_range.css({ height: '' });
		dropdown.attr('data-status', 'closed');
		$('body').off('click', onClickOutside);
	}
	function toggle() {
		if ( dropdown.attr('data-status') == 'closed' ) {
			open();
		} else {
			close();
		}
	}
	
	
	// Event Clicks
	// 
	function onClickOutside( event ) {
		if ( !$(event.target).closest( popout ).length ) {
			close();
		}
	}
	
	
	// Select option
	// 
	function select( label, value ) {
		// If has changed
		if ( value !== INSTANCE.value ) {
			// Select option
			$('li.selected', popout_range_list).removeClass('selected');
			$('li[data-value="' + value + '"]', popout_range_list).addClass('selected');
			
			// Update label
			display_label.html( label );
			
			// Update value
			INSTANCE.value = value;
			
			// Announce change
			INSTANCE.dispatchEvent('change', [ value ]);
		}
		
		// Close
		close();
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Disable / Enable
	// 
	INSTANCE.disable = function() {
		dropdown.attr('data-status', 'disabled');
	};
	INSTANCE.enable = function() {
		dropdown.attr('data-status', 'closed');
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};